import { gql } from '@lcs/shared/api';

export const getPhonesQuery = gql`
   query GetPhones($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      phonesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            phoneId
            phoneType
            numberOfLineKeys
            handsetIpei
            sipUsername
            domain
            displayName
            phoneTypeName
            adminPassword
            baseStationHandsetsConnection {
               items {
                  baseStationHandsetId
                  phoneId
                  sortId
                  device {
                     deviceId
                     deviceTypeId
                     macAddress
                     description
                  }
               }
            }
            sipUsersConnection {
               items {
                  sipUserId
                  userName
                  hashPassword
                  userAgents
                  externalIps
                  internalIps
                  accountId
                  isConnected
               }
            }
            extension {
               account {
                  domain
               }
            }
            createDate
            createUser {
               name
            }
            updateDate
            updateUser {
               name
            }
            devicesConnection {
               items {
                  deviceId
                  macAddress
                  deviceTypeId
                  accountId
                  phoneId
                  ztStatus
               }
            }
         }
      }
   }
`;
